import Basic from "./Basic"
import ModalComponent from './AntDesignModal';

export default {
    Basic,
    ModalComponent

}
